import { render, staticRenderFns } from "./DSPTableTabs.vue?vue&type=template&id=58560bda&"
import script from "./DSPTableTabs.vue?vue&type=script&lang=js&"
export * from "./DSPTableTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports